
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiInputKeyboardGoogle as ObiInputKeyboardGoogleElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-input-keyboard-google.js';
 
 
 

 
 export const ObiInputKeyboardGoogle = createComponent({
   react: React,
   tagName: 'obi-input-keyboard-google',
   elementClass: ObiInputKeyboardGoogleElement,
   events: {
     
   }
  });
 
 